import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { MenuItemCard } from '../home/MenuItemCard.jsx';
import { useMenuStore } from '../../stores/menuStore.js';

/**
 * Mobile menu grid — fixed 3 cards per row.
 */
export const MobileMenuGrid = ({
  filteredItems,
  isLoading,
  searchQuery,
  onClearFilters,
  hasItems,
}) => {
  const { cart, addToCart } = useMenuStore();

  const getCartQty = (itemId) => {
    const cartItem = cart.find((c) => c.itemID === itemId);
    return cartItem ? cartItem.quantity : 0;
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, py: 6 }}>
        <CircularProgress size={28} sx={{ color: 'text.secondary' }} />
      </Box>
    );
  }

  if (filteredItems.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1,
          opacity: 0.5,
          py: 6,
        }}
      >
        <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 500 }}>
          {!hasItems ? 'No menu items available' : 'No items match your search'}
        </Typography>
        {searchQuery && (
          <Typography
            variant="body2"
            sx={{ color: '#007AFF', cursor: 'pointer', mt: 1, fontWeight: 500 }}
            onClick={onClearFilters}
          >
            Clear filters
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, overflowY: 'auto', px: 1.5, pb: 2 }}>
      <Box
        sx={{
          display: 'grid',
          // Min 3 columns, but more if screen allows (auto-fill)
          // calc((100% - 2*gap) / 3) ensures 3 fit; auto-fill adds more on wider screens
          gridTemplateColumns: 'repeat(auto-fill, minmax(calc(33.33% - 6px), 1fr))',
          gap: 1,
          alignContent: 'start',
          pt: 0.5,
        }}
      >
        {filteredItems.map((item) => (
          <MenuItemCard
            key={item.itemID}
            item={item}
            quantity={getCartQty(item.itemID)}
            onTap={() => addToCart(item, 1)}
          />
        ))}
      </Box>
    </Box>
  );
};
